import { render, staticRenderFns } from "./PuzzleImageThumb.vue?vue&type=template&id=26d80def&scoped=true&"
import script from "./PuzzleImageThumb.vue?vue&type=script&lang=ts&"
export * from "./PuzzleImageThumb.vue?vue&type=script&lang=ts&"
import style0 from "./PuzzleImageThumb.vue?vue&type=style&index=0&id=26d80def&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d80def",
  null
  
)

export default component.exports